export enum TransportMode {
    Air = 'A',
    Sea = 'S'
}

export enum ShipmentDirection {
    Import = 1,
    Export = 2
}

export enum CargoMode {
    FCL = 'FCL',
    LCL = 'LCL',
}